module.exports = __webpack_public_path__ + "img/Group 424.12929634.png";